import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { PROCESS_AG_COPROPRIETES } from '../../../../config/process-ag-coproprietes';

export default function VoteAgPage() {
  const item = PROCESS_AG_COPROPRIETES.find((p) => p.slug === 'vote');
  if (!item) return null;
  return (
    <AudienceParcoursStubPage
      parcours={item}
      audienceId="coproprietes"
      segment="process-ag"
      segmentLabel="Process AG"
      ctaFinalOverride={{
        eyebrow: 'Préparer l\u2019AG en amont',
        title: 'Un vote en 1re convocation, ça se prépare',
        description:
          "Réunion d\u2019information avant l\u2019AG, recueil des pouvoirs, réponses aux objections classiques, passage de l\u2019art. 25 à l\u2019art. 25-1 si besoin : on cale le scénario avec votre conseil syndical pour éviter un report.",
        primary: { label: 'Cadrer la stratégie de vote', href: '/contact?source=coproprietes&besoin=strategie-vote-ag' },
        secondary: { label: 'Calculer les aides Copro', href: '/coproprietes/calculer-mes-aides' },
        bullets: ['Présentation AG offerte', 'Pouvoirs encadrés', 'PV et notifications conformes'],
      }}
    />
  );
}
